// ============================================
// CONSTANTS.JS - Constante și date inițiale
// ============================================

// Cheie pentru localStorage
export const STORAGE_KEY = 'amiabila_form_data';

// Lista împrejurărilor (circumstanțe accident)
export const IMPREJURARI_DATA = [
  { id: 1, text: 'în staționare / oprit' },
  { id: 2, text: 'la momentul plecării / deschizând portiera' },
  { id: 3, text: 'la momentul opririi' },
  { id: 4, text: 'ieșind dintr-o parcare auto, loc privat' },
  { id: 5, text: 'intrând într-o parcare auto, loc privat' },
  { id: 6, text: 'intrând într-un sens giratoriu' },
  { id: 7, text: 'circulând într-un sens giratoriu' },
  { id: 8, text: 'lovind spatele unui vehicul (pe același sens/bandă)' },
  { id: 9, text: 'deplasându-se în același sens, benzi diferite' },
  { id: 10, text: 'schimbând banda de circulație' },
  { id: 11, text: 'depășind' },
  { id: 12, text: 'virând la dreapta' },
  { id: 13, text: 'virând la stânga' },
  { id: 14, text: 'mergând cu spatele' },
  { id: 15, text: 'intrând pe banda pt. circulație în sens opus' },
  { id: 16, text: 'venind din dreapta (într-o intersecție)' },
  { id: 17, text: 'neobservând indicatorul de prioritate / semafor' }
];

// Starea inițială goală a formularului
export const getInitialFormData = () => ({
  // Date accident
  dataAccident: new Date().toISOString().split('T')[0],
  oraAccident: '',
  locAccident: '',
  taraAccident: 'Romania',
  vatamariCorporale: 'nu',
  pagubeVehicule: 'nu',
  pagubeObiecte: 'nu',
  martori: '',
  
  // Observații
  observatiiA: '',
  observatiiB: '',
  
  // Vehicul A
  vehiculA: {
    asigurat: { 
      nume: '', 
      prenume: '', 
      adresa: '', 
      codPostal: '', 
      tara: 'Romania', 
      tel: '' 
    },
    vehicul: { 
      marca: '', 
      nrInmatriculare: '', 
      taraInmatriculare: 'Romania' 
    },
    remorca: { 
      nrInmatriculare: '', 
      taraInmatriculare: 'Romania' 
    },
    asigurare: { 
      denumire: '', 
      politaNr: '', 
      carteVerdeNr: '', 
      valabilDeLa: '', 
      valabilPanaLa: '' 
    },
    casco: 'nu',
    conducator: { 
      nume: '', 
      prenume: '', 
      dataNasterii: '', 
      adresa: '', 
      tara: 'Romania', 
      tel: '', 
      permisNr: '', 
      categorie: '', 
      permisValabil: '' 
    },
    conducatorEsteProprietar: false,
    pagube: ''
  },
  
  // Vehicul B
  vehiculB: {
    asigurat: { 
      nume: '', 
      prenume: '', 
      adresa: '', 
      codPostal: '', 
      tara: 'Romania', 
      tel: '' 
    },
    vehicul: { 
      marca: '', 
      nrInmatriculare: '', 
      taraInmatriculare: 'Romania' 
    },
    remorca: { 
      nrInmatriculare: '', 
      taraInmatriculare: 'Romania' 
    },
    asigurare: { 
      denumire: '', 
      politaNr: '', 
      carteVerdeNr: '', 
      valabilDeLa: '', 
      valabilPanaLa: '' 
    },
    casco: 'nu',
    conducator: { 
      nume: '', 
      prenume: '', 
      dataNasterii: '', 
      adresa: '', 
      tara: 'Romania', 
      tel: '', 
      permisNr: '', 
      categorie: '', 
      permisValabil: '' 
    },
    conducatorEsteProprietar: false,
    pagube: ''
  },
  
  // Împrejurări bifate
  imprejurariA: [],
  imprejurariB: [],
  
  // Schița accidentului (null = fără schiță / grilă manuală)
  sketchData: null
});

// Funcție pentru încărcare din localStorage
export const loadFromStorage = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      const initial = getInitialFormData();
      
      // Merge datele salvate cu structura inițială
      // pentru a asigura că toate câmpurile există
      return {
        ...initial,
        ...parsed,
        vehiculA: { 
          ...initial.vehiculA, 
          ...parsed.vehiculA,
          asigurat: { ...initial.vehiculA.asigurat, ...(parsed.vehiculA?.asigurat || {}) },
          vehicul: { ...initial.vehiculA.vehicul, ...(parsed.vehiculA?.vehicul || {}) },
          remorca: { ...initial.vehiculA.remorca, ...(parsed.vehiculA?.remorca || {}) },
          asigurare: { ...initial.vehiculA.asigurare, ...(parsed.vehiculA?.asigurare || {}) },
          conducator: { ...initial.vehiculA.conducator, ...(parsed.vehiculA?.conducator || {}) }
        },
        vehiculB: { 
          ...initial.vehiculB, 
          ...parsed.vehiculB,
          asigurat: { ...initial.vehiculB.asigurat, ...(parsed.vehiculB?.asigurat || {}) },
          vehicul: { ...initial.vehiculB.vehicul, ...(parsed.vehiculB?.vehicul || {}) },
          remorca: { ...initial.vehiculB.remorca, ...(parsed.vehiculB?.remorca || {}) },
          asigurare: { ...initial.vehiculB.asigurare, ...(parsed.vehiculB?.asigurare || {}) },
          conducator: { ...initial.vehiculB.conducator, ...(parsed.vehiculB?.conducator || {}) }
        }
      };
    }
  } catch (e) {
    console.error('Eroare la încărcarea datelor salvate:', e);
  }
  return getInitialFormData();
};

// Funcție pentru salvare în localStorage
export const saveToStorage = (formData) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(formData));
    return true;
  } catch (e) {
    console.error('Eroare la salvarea datelor:', e);
    return false;
  }
};

// Funcție pentru ștergere din localStorage
export const clearStorage = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (e) {
    console.error('Eroare la ștergerea datelor:', e);
    return false;
  }
};